import { createSlice } from "@reduxjs/toolkit";

const authSlice = createSlice({
    name: 'auth',
    initialState: {
      isAuthenticated: Boolean(localStorage.getItem('Berlin-Auth-Token')),
    },
    reducers: {
      login(state) {
        const token = "Berlin-React";
        localStorage.setItem('Berlin-Auth-Token', JSON.stringify(token));
        state.isAuthenticated = true;
      },
      logout(state) {
        localStorage.removeItem('Berlin-Auth-Token');
        state.isAuthenticated = false;
      },
    },
  });
  
  export const { login, logout } = authSlice.actions;
  export default authSlice.reducer;